import accordionScript from "./blocks/accordion";
import accordionTeamScript from "./blocks/accordionTeam";
import boxSliderScript from "./blocks/boxSlider";
import gatheringsScript from "./blocks/gatherings";
import reportFilterScript from "./blocks/reportFilter";
import headerScript from "./blocks/header";

function onReady() {
  accordionScript();
  accordionTeamScript();
  boxSliderScript();
  gatheringsScript();
  reportFilterScript();
  headerScript();
}

if (document.readyState !== "loading") {
  onReady();
} else {
  document.addEventListener("DOMContentLoaded", onReady);
}
